module.exports = __webpack_public_path__ + "img/alpha10.b0d6e2a4.png";